module.exports = __webpack_public_path__ + "38cd0d2f26e7d5f227cb4a54a8a772d0.png";